var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"c-list-images t-black t-description"},_vm._l((_vm.imagesArray),function(image,index){return _c('Screen',{key:index,attrs:{"image":image || null}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }